import { Disclosure } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';
import InnerCheckbox from '../../../Disciplines/components/exercises/components/innerCheckbox';
import { favoriteFilterStore } from '../../stores/favoriteFilterStore';
import './styles.css';

interface IModalFilter {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function FilterTheme({
  isOpen,
  onClose,
  onSubmit,
}: IModalFilter) {
  const {
    category,
    discipline,
    setCategory,
    setDiscipline,
    addCategory,
    addDiscipline,
    removeCategory,
    removeDiscipline,
    resetFilter,
  } = favoriteFilterStore();

  const [isClean, setIsClean] = useState<boolean>(false);
  const [categoryAux, setCategoryAux] = useState<string[]>([]);
  const [disciplineAux, setDisciplineAux] = useState<string[]>([]);

  const handleCategory = (categoria: string) => {
    if (isClean) {
      setIsClean(false);
    }

    const aux = [...category];

    if (aux.includes(categoria)) {
      removeCategory(categoria);
    } else {
      addCategory(categoria);
    }
  };

  const handleDiscipline = (disciplina: string) => {
    if (isClean) {
      setIsClean(false);
    }

    const aux = [...discipline];

    if (aux.includes(disciplina)) {
      removeDiscipline(disciplina);
    } else {
      addDiscipline(disciplina);
    }
  };

  const reset = () => {
    setIsClean(true);
    setCategoryAux(category);
    setDisciplineAux(discipline);
    resetFilter();
  };

  const handleSubmit = () => {
    if (isClean) {
      setIsClean(false);
      resetFilter();
      onSubmit();
    } else {
      setCategoryAux([]);
      setDisciplineAux([]);

      onSubmit();
    }
  };

  const abbandon = () => {
    if (isClean) {
      setCategory(categoryAux);
      setDiscipline(disciplineAux);
      setIsClean(false);
    }

    onClose();
  };

  return (
    <Modal
      position={window.innerWidth < 768 ? 'bottom' : 'top-right'}
      size='md'
      isOpen={isOpen}
      onClose={() => abbandon()}
      className='xs:h-[90vh] xs:w-full sm:h-[75vh] md:h-[95vh] md:w-[35%]'
      title='Filtrar temas'
    >
      <div
        id='filterContainer'
        className='flex w-full flex-col gap-md overflow-x-auto px-2 py-2 xs:h-[58vh] sm:h-[48vh] md:h-[75vh]'
      >
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Tipo de conteúdo
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleCategory('lesson')}
                  label='Videoaulas'
                  checked={category.indexOf('lesson') >= 0}
                  id='category-lesson'
                  value='lesson'
                />
                <InnerCheckbox
                  onChange={() => handleCategory('exercise')}
                  label='Exercícios'
                  checked={category.indexOf('exercise') >= 0}
                  id='category-exercise'
                  value='exercise'
                />
                <InnerCheckbox
                  onChange={() => {
                    handleCategory('apostila');
                    handleCategory('mapamental');
                  }}
                  label='Materiais'
                  checked={
                    category.indexOf('apostila') >= 0 ||
                    category.indexOf('mapamental') >= 0
                  }
                  id='category-material'
                  value='material'
                />
                {/* @audit Podcasts removido */}
                {/* <InnerCheckbox
                  onChange={() => handleCategory('audio')}
                  label='Podcasts'
                  checked={category.indexOf('audio') >= 0}
                  id='category-audio'
                  value='audio'
                /> */}
                <InnerCheckbox
                  onChange={() => handleCategory('live')}
                  label='Lives'
                  checked={category.indexOf('live') >= 0}
                  id='category-live'
                  value='live'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='w-full border-b-hairline border-mono-color-light' />
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Disciplinas
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleDiscipline('biologia')}
                  label='Biologia'
                  checked={discipline.indexOf('biologia') >= 0}
                  id='disciplines-biologia'
                  value='biologia'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('fisica')}
                  label='Física'
                  checked={discipline.indexOf('fisica') >= 0}
                  id='disciplines-fisica'
                  value='fisica'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('quimica')}
                  label='Química'
                  checked={discipline.indexOf('quimica') >= 0}
                  id='disciplines-quimica'
                  value='quimica'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('matematica')}
                  label='Matemática'
                  checked={discipline.indexOf('matematica') >= 0}
                  id='disciplines-matemática'
                  value='matematica'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('historia')}
                  label='História'
                  checked={discipline.indexOf('historia') >= 0}
                  id='disciplines-historia'
                  value='historia'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('geografia')}
                  label='Geografia'
                  checked={discipline.indexOf('geografia') >= 0}
                  id='disciplines-geografia'
                  value='geografia'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('atualidades')}
                  label='Atualidades'
                  checked={discipline.indexOf('atualidades') >= 0}
                  id='disciplines-atualidades'
                  value='atualidades'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('filosofia')}
                  label='Filosofia'
                  checked={discipline.indexOf('filosofia') >= 0}
                  id='disciplines-filosofia'
                  value='filosofia'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('portugues')}
                  label='Português'
                  checked={discipline.indexOf('portugues') >= 0}
                  id='disciplines-portugues'
                  value='portugues'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('literatura')}
                  label='Literatura'
                  checked={discipline.indexOf('literatura') >= 0}
                  id='disciplines-literatura'
                  value='literatura'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('ingles')}
                  label='Inglês'
                  checked={discipline.indexOf('ingles') >= 0}
                  id='disciplines-ingles'
                  value='ingles'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('espanhol')}
                  label='Espanhol'
                  checked={discipline.indexOf('espanhol') >= 0}
                  id='disciplines-espanhol'
                  value='espanhol'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('interdisciplinar')}
                  label='Interdisciplinar'
                  checked={discipline.indexOf('interdisciplinar') >= 0}
                  id='disciplines-intercisplinar'
                  value='interdisciplinar'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('redacao')}
                  label='Redação'
                  checked={discipline.indexOf('redacao') >= 0}
                  id='disciplines-redacao'
                  value='redacao'
                />
                <InnerCheckbox
                  onChange={() => handleDiscipline('sociologia')}
                  label='Sociologia'
                  checked={discipline.indexOf('sociologia') >= 0}
                  id='disciplines-sociologia'
                  value='sociologia'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='w-full border-b-hairline border-mono-color-light' />
      </div>
      <div className='fixed bottom-0 left-0 flex w-full flex-row items-center justify-center gap-lg px-4 py-5'>
        <Button
          variant='text'
          className='w-1/2 xs:text-sm md:text-md'
          full
          onClick={() => reset()}
        >
          <Icon Icon='delete' type='material' className='text-sm' />
          Limpar seleção
        </Button>
        <Button
          className='w-1/2 xs:text-sm md:text-md'
          full
          onClick={() => handleSubmit()}
        >
          Aplicar filtros
        </Button>
      </div>
    </Modal>
  );
}
